<template>
    <div
        class="tw-w-max tw-flex tw-flex-col tw-justify-between md:tw-gap-2 font-right-navbar tw-cursor-pointer"
        @click="goToCart"
    >
        <div class="tw-self-center tw-relative">
            <q-icon
                name="shopping_cart"
                size="20px"
                :class="`${shopCart.count > 0 && 'shake'} !tw-text-[30px] md:!tw-text-[35px] tw-text-primary md:tw-text-customGray-300 hover:tw-text-primary hover:tw-transition-all hover:tw-duration-700`"
            />
            <q-badge
                rounded
                class="tw-text-white tw-bg-secondary tw-absolute -tw-top-2 -tw-right-2"
                floating
                v-show="shopCart.count > 0"
            >
                {{ shopCart.count }}
            </q-badge>
        </div>
        <q-spinner-ios
            size="20px"
            class="tw-hidden md:tw-flex tw-text-customGray-500 tw-mx-auto"
            v-if="loadingShopCart"
        />
        <span
            class="tw-hidden md:tw-flex md:tw-text-lg tw-text-customGray-500"
            v-else-if="shopCart.subtotal_formatted"
        >
            {{ shopCart.subtotal_formatted }}
        </span>
        <span
            class="tw-hidden md:tw-flex md:tw-text-lg tw-text-customGray-500"
            v-else
        >
            $00.00
        </span>
    </div>
</template>
<script lang="ts" setup>
import { useShopCartStore } from "~/stores/shopCartStore"
import { useProvinceSelection } from "~/composables/useProvinceSelection"

const router = useRouter()
const shopCartStore = useShopCartStore()
const { shopCart, loadingShopCart } = storeToRefs(shopCartStore)
const { isValidProvinceSelected, openProvinceModalForCart } = useProvinceSelection()

async function goToCart() {
    if (!isValidProvinceSelected.value) {
        openProvinceModalForCart()
        return
    }
    router.push({ path: "/cart" })
}
</script>
